import { Box, TableCell, TableRow, Theme, Typography, useTheme } from "@mui/material";
import { RecentRecommendationsTableBodyProps, TableBodyData } from "../../types";
import { checkImageExists } from "../../../../utils/utilityFunctions";

export default function RecentRecommendationsTableBody(
    {
        tableBodyData,
        tableBodyRowCustomStyles,
    }: RecentRecommendationsTableBodyProps
): JSX.Element {
    const theme = useTheme()

    return (
        <>
            {tableBodyData.map((obj: TableBodyData) => {
                const amcIds = ['BDOTR', 'BPIAMC']
                const checkAmcId = amcIds.includes(obj.amcId ?? '') ? obj.amcId?.toLowerCase() : obj.amcId;
                return (
                    <TableRow
                        key={obj.id}
                        sx={{
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            ...tableBodyRowCustomStyles
                        }}
                    >
                        {obj.schemeName && (
                            <TableCell
                                align="left"
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '8px' }}>
                                    <img
                                        src={checkImageExists(checkAmcId) ? `../../../../../../images/amcIcons/${checkAmcId}.svg` : `../../../../../../images/amcIcons/default.svg`}
                                        alt=""
                                        aria-hidden="true"
                                        role="presentation"
                                        width={35}
                                        height={35}
                                        style={{
                                            objectFit: "contain",
                                            borderRadius: "8px"
                                        }}
                                    />
                                    <Typography variant="body_500" sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        '&:hover': {
                                            color: theme.palette.primary[500]
                                        },
                                    })}>{obj?.schemeName}</Typography>

                                </Box>
                            </TableCell>
                        )}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.status ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.transactionType ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.amount ?? 0}
                            </Typography>
                        </TableCell>

                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.recommendedUnits ?? 0}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.date ?? '-'}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}